import moment from 'moment-timezone'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import store from './store/store'
import {dataExtenso} from "@/plugins/webdom";

Vue.config.productionTip = false;

Vue.filter('getDayHTML', function (value) {
  if (value) {
    const date = moment(String(value)).add(3, 'h');
    return date.format('DD/MM/YYYY')
  }
});

Vue.filter('padDigits', function (number) {
  let valor = Array(Math.max(3 - String(number).length + 1, 0)).join(0) + number;
  return valor.toString()
});

Vue.filter('anoCriacao', function (ent_ano_criacao) {
  const anoAtual = new Date().getFullYear();
  const anoCriacao = (anoAtual - ent_ano_criacao) + 1;

  switch (anoCriacao) {
    case 1:
      return 'I';
    case 2:
      return 'II';
    case 3:
      return 'III';
    case 4:
      return 'IV';
    case 5:
      return 'V';
    case 6:
      return 'VI';
    case 7:
      return 'VII';
    case 8:
      return 'VIII';
    case 9:
      return 'IX';
    case 10:
      return 'X';
    case 11:
      return 'XI';
    case 12:
      return 'XII';
    case 13:
      return 'XIII';
    case 14:
      return 'XIV';
    case 15:
      return 'XV';
    case 16:
      return 'XVI';
    case 17:
      return 'XVII';
    case 18:
      return 'XVIII';
    case 19:
      return 'XIX';
    case 20:
      return 'XX';
    default:
      return 'SEM ANO';
  }
});

Vue.filter('dateExtensao', function (data) {
  return dataExtenso(data);
});

Vue.use(ArgonDashboard);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
